module.exports = __webpack_public_path__ + "img/st2.png";